<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Store Requisition</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Store</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  class="btn add-btn"
                  @click="onSubmitForApproval"
                  v-if="
                    expense.status == 7 &&
                      expense.requestBy == currentUser.employee.id
                  "
                  ><i class="fa fa-ticket"></i> Submit for Approval</a
                >
                <a
                  class="btn add-btn"
                  @click="onSubmitForConfirm"
                  v-if="
                    expense.status == 1 && currentUser.roles.includes('STORE OFFICER')
                  "
                  ><i class="fa fa-ticket"></i> Confirm</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="
                                expense.requestBy == currentUser.employee.id
                              "
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="expense.requestDate"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    :disabled="
                                      currentUser.employee.id !==
                                        expense.requestBy
                                    "
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="expense.requestBy"
                                  disabled
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-10">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="expense.description"
                                  :disabled="
                                    currentUser.employee.id !==
                                      expense.requestBy
                                  "
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="this.expenseId > 0">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        <button class="btn collapsed">
                          Store Requisition Lines ({{
                            expense.storeRequisitionItems &&
                              expense.storeRequisitionItems.length
                          }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogMeasurement"
                            class="btn text-primary ml-3"
                            v-if="expense.requestBy == currentUser.employee.id"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogMeasurement" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Store Requisition Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                <label>Product</label>

                <multiselectvue
                  class="from-control"
                  v-model="productName"
                  placeholder="Select Product"
                  :custom-label="nameOfProduct"
                  :options="sortedProductNames"
                  :searchable="true"
                  @select="optionSelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.productName }}</template
                  >
                </multiselectvue>

                <!-- <select class="form-control" v-model="manager">
                  <option>Select Staff</option>
                  <option
                    v-for="member in employees"
                    :key="member.id"
                    :value="member.id"
                  >
                    {{ member.lastName + " " + member.firstName }}
                  </option>
                </select> -->
              </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.quantity"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Store Requisition Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Product Name
                                            <span class="text-danger">*</span>
                                          </label>
                                         <multiselectvue
                  class="from-control"
                  v-model="productName"
                  placeholder="Select Product"
                  :custom-label="nameOfProduct"
                  :options="sortedProductNames"
                  :searchable="true"
                  @select="optionSelected"
                  :allow-empty="false"
                >
                  <template slot="singleLabel" slot-scope="{ option }"
                    >{{ option.productName }}</template
                  >
                </multiselectvue>
                                        </div>
                                      </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="expenseItem.quantity"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteMeasurement"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteMeasurement"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>

                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersM"
                                :items="expense.storeRequisitionItems"
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div
                                    class="dropdown dropdown-action"
                                    v-if="
                                      (expense.status == 7 &&
                                        expense.requestBy ==
                                          currentUser.employee.id) || (expense.status == 1 && currentUser.roles.includes('STORE OFFICER')
                                          )
                                    "
                                  >
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openDialogEditMeasurement(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteMeasurement(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import vueDynamicForms from "vuejs-dynamic-forms";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    vueDynamicForms
  },
  data() {
    return {
      expenseId: this.$route.params.id,
      expenseTypeId: 0,
      dialogMeasurement: false,
      dialogEditMeasurement: false,
      dialogDeleteMeasurement: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      headersM: [
        {
          text: "Product Description",
          align: "start",
          value: "productName"
        },
        { text: "Quantity", value: "quantity" },
        { text: "", value: "actions", sortable: false }
      ],
      banks: [],
      employees: [],
      products: [],
      expense: {
        requestDate: new Date(),
        requestBy: authenticationService.currentUserValue
          ? authenticationService.currentUserValue.employee.id
          : 0,
        description: "",
        storeRequisitionItems: []
      },
      expenseItem: {},
      productName: "",
      message: "",
      error: ""
    };
  },
  computed: {
    sortedProductNames: function() {
      function compare(a, b) {
        if (a.productName.toLowerCase() < b.productName.toLowerCase()) return -1;
        if (a.productName.toLowerCase() > b.productName.toLowerCase()) return 1;
        return 0;
      }

      return this.products.sort(compare);
    }
  },
  methods: {
    nameOfProduct({ productName }) {
      return `${productName}`;
    },

    optionSelected(option, id) {
      
      this.expenseItem.productName = option.productName;
      this.expenseItem.productNo = option.productNo;
      console.log(this.expenseItem);
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getProducts() {
      employeeService.getProducts().then(
        model => {
          this.products = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getStoreRequisition() {
      employeeService.getStoreRequisitionById(this.expenseId).then(
        model => {
          console.log(model);
          this.expense = model;
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      if (this.expense.description == "") {
        this.error = "enter description";
        return;
      }

      this.loading = true;
      if (!this.expenseId) {
        employeeService.addStoreRequisition(this.expense).then(
          id => {
            this.$router.push("/store-requisition-employee");
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      } else {
        employeeService.updateStoreRequisition(this.expense).then(
          id => {
            this.getStoreRequisition();
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      }
    },
    onSubmitForApproval() {
      if (this.expense.storeRequisitionItems.length === 0) {
        this.error = "enter product name and quantity";
        console.log("stop");
        return;
      } else {
        this.expense.status = 0;
        employeeService.updateStoreRequisition(this.expense).then(
          id => {
            this.message = "Requisition submitted successfully !";
            this.$router.push("/store-requisition-employee");
            this.getStoreRequisition();
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      }
    },
    onSubmitForConfirm() {
      if (this.expense.storeRequisitionItems.length === 0) {
        this.error = "enter product name and quantity";
        console.log("stop");
        return;
      } else {
        this.expense.status = 3;
        employeeService.updateStoreRequisition(this.expense).then(
          id => {
            this.message = "Requisition confirmed successfully !";
            this.$router.push("/store-requisition-store");
            this.getStoreRequisition();
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      }
    },
    onSubmitMeasurement() {
      this.expenseItem.storeRequisitionId = this.expenseId;
      employeeService.addStoreRequisitionItem(this.expenseItem).then(
        model => {
          this.closeMeasurement();
          this.expenseItem = {};
          this.getStoreRequisition();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditMeasurement() {
      employeeService.updateStoreRequisitionItem(this.expenseItem).then(
        model => {
          this.closeEditMeasurement();
          this.expenseItem = {};
          this.getStoreRequisition();
        },
        error => {
          this.error = error;
        }
      );
    },
    onDeleteMeasurement() {
      employeeService
        .removeStoreRequisitionItem(this.expenseItem.id)
        .then(model => {
          this.getStoreRequisition();
          this.expenseItem = {};
          this.closeDeleteMeasurement();
        });
    },
    closeDeleteMeasurement() {
      this.dialogDeleteMeasurement = false;
    },
    closeMeasurement() {
      this.dialogMeasurement = false;
    },
    closeEditMeasurement() {
      this.dialogEditMeasurement = false;
    },
    openDialogMeasurement() {
      this.message = "";
      this.error = "";
      this.dialogMeasurement = true;
    },
    openDialogEditMeasurement(item) {
      this.message = "";
      this.error = "";
      console.log(`item`, item);
      this.expenseItem = item;
      this.productName = item.productName;
      this.dialogEditMeasurement = true;
    },
    openDeleteMeasurement(item) {
      this.expenseItem = item;
      this.dialogDeleteMeasurement = true;
    }
  },
  mounted() {
    this.getEmployees();
    this.getProducts();
    this.getStoreRequisition();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/StoreRequisition/detail2.vue